import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const ProvidersService = {
  getProviders: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/providers/whatsapp`);
  },
  getProvidersRCS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/providers/rcs`);
  },
  getProvidersSMS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/providers/sms`);
  }
};
